import { useCallback, useState } from 'react'

import type { Variant } from '../../../types/graphql'

/**
 * @deprecate Just leverage useCart and useCartDialog or VariantSelectionForm's submit options.
 */
export function useVariantValidator({ selectedVariant }: { selectedVariant?: Variant }) {
  const [invalid, setInvalid] = useState(false)

  const reset = useCallback(() => setInvalid(false), [setInvalid])

  const validate = useCallback(() => {
    const valid = !!selectedVariant && !selectedVariant.soldOut
    setInvalid(!valid)
    return valid
  }, [setInvalid, selectedVariant])

  return { invalid, reset, validate }
}
